import React from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import { useNavigate } from "react-router-dom";
import {
  Button,
  CustomInput,
  Description,
  SubTitle,
  UnorderedList,
} from "../../Components/CustomComponents";
import { WEB_ROUTES } from "../../constants";
import { useChangePassMutation } from "../../Data/services/changePassApi";
import Toast from "../../Hooks/useToast";
import styles from "./styles/ChangePassword.module.scss";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";

export default function ChangePassword() {
  const { handleSubmit, control, register } = useForm();
  const [changePassword, { isSuccess, isLoading, isError }] =
    useChangePassMutation();
  const navigate = useNavigate();
  const handleDataSubmission = async (userData) => {
    try {
      // Use unwrap() to get the response userData directly
      const response = await changePassword(userData).unwrap();
      navigate(WEB_ROUTES.DASHBOARD);
      Toast(response?.data?.message, "success");
    } catch (error) {
      Toast(error?.data?.message, "error");
    }
  };
  return (
    <div className={styles.ChangePassword}>
      <SubTitle text="Change Password" />
      <Description
        text="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        classes="fs-8 mb-4"
      />
      <Form onSubmit={handleSubmit(handleDataSubmission)}>
        <div className={styles.form}>
          <Description text="Current Password" classes="mb-1" />
          <Controller
            control={control}
            name="current_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="Current Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <Description text="Set New Password" classes="mt-3 mb-1" />
          <Controller
            control={control}
            name="new_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="New Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="confirm_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="Confirm Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <UnorderedList
            lists={[
              "At least 12 characters long but 14 or more is better.",
              "A combination of uppercase letters, lowercase letters, numbers, and symbols.",
            ]}
            classes="fs-6 mt-4 mb-4"
          />

          <div className={styles.saveButton}>
            <Button
              text={<>{isLoading ? <LoadingButton /> : "Change Password"}</>}
              classes="fs-6 mb-2 mt-auto"
              type="submit"
            />
          </div>
        </div>
      </Form>
    </div>
  );
}
